/**
 * @module actions/orders
 */
import axios from 'axios'
import {
  API_URL,
  // FILE_STORAGE,
  FILE_STORAGE_API,
  SET_ORDER,
  SET_ORDERS,
  SET_WORKSCREEN_ORDERS,
  SET_WORKCARD_ORDER,
  SET_ORDERS_ERRORS,
  // SET_ORDER_FILTER,
  SET_ORDERLIST_FILTER,
  SET_WORKSCREEN_ORDER_FILTER,
  SET_CUSTOMER_ORDER_FILTER,
  SET_WP_ORDER_FILTER,
  RESET_ORDERLIST_FILTER,
  RESET_WORKSCREEN_ORDER_FILTER,
  RESET_CUSTOMER_ORDER_FILTER,
  RESET_WP_ORDER_FILTER,
  SET_SIMPLESEARCH,
  SET_SIMPLESEARCH_WORKSCREEN,
  RESET_SIMPLESEARCH,
  RESET_SIMPLESEARCH_WORKSCREEN,
  SET_ORDERS_SEARCH,
  SET_LAST_VISITED_ORDER
} from '../constants'

// import { filterSearch } from '../utils/filter'
import { hasAccess } from '../utils/auth'
import { queueUpload } from '../utils/upload'

export function resetOrderFilter (source) {
  switch (source) {
    case 'orderlist':
      return {
        type: RESET_ORDERLIST_FILTER
      }
    case 'workscreen':
      return {
        type: RESET_WORKSCREEN_ORDER_FILTER
      }
    case 'customer':
      return {
        type: RESET_CUSTOMER_ORDER_FILTER
      }
    case 'wp':
      return {
        type: RESET_WP_ORDER_FILTER
      }
  }
  // return {
  //   type: RESET_ORDER_FILTER
  // }
}

export function setOrdersFilter (filter, source) {
  // set local storage for filter
  // window.localStorage.setItem('user_token', token)
  // window.localStorage.setItem('user_data', JSON.stringify(res.data))
  // console.log('setOrdersFilter filter, source', filter, source)
  switch (source) {
    case 'orderlist':
      window.localStorage.setItem('filterOrderlist', JSON.stringify(filter))
      return {
        type: SET_ORDERLIST_FILTER,
        filter
      }
    case 'workscreen':
      window.localStorage.setItem('filterWorkscreen', JSON.stringify(filter))
      return {
        type: SET_WORKSCREEN_ORDER_FILTER,
        filter
      }
    case 'customer':
      window.localStorage.setItem('filterCustomer', JSON.stringify(filter))
      return {
        type: SET_CUSTOMER_ORDER_FILTER,
        filter
      }
    case 'wp':
      window.localStorage.setItem('filterWP', JSON.stringify(filter))
      return {
        type: SET_WP_ORDER_FILTER,
        filter
      }
  }

  // window.localStorage.setItem('ordersFilter', JSON.stringify(filter))
  // return {
  //   type: SET_ORDER_FILTER,
  //   filter
  // }
}
export function setOrdersSearch (isSearching) {
  return {
    type: SET_ORDERS_SEARCH,
    isSearching: isSearching
  }
}

export function SetWorkcardOrderAction (order) {
  return {
    type: SET_WORKCARD_ORDER,
    order
  }
}
export function SetOrderAction (order) {
  return {
    type: SET_ORDER,
    order
  }
}

export function setOrderErrors (error) {
  return {
    type: SET_ORDERS_ERRORS,
    error
  }
}

export function resetSimplesearchType (source) {
  let simpleSearch = { save: true, value: '' }
  if (source === 'workscreen') {
    window.localStorage.setItem('simplesearchWorkscreen', JSON.stringify(simpleSearch))
    return {
      type: RESET_SIMPLESEARCH_WORKSCREEN
    }
  } else {
    window.localStorage.setItem('simpleSearch', JSON.stringify(simpleSearch))
    return {
      type: RESET_SIMPLESEARCH
    }
  }
}

export function setSimplesearchType (simplesearch, source) {
  if (source === 'workscreen') {
    window.localStorage.setItem('simplesearchWorkscreen', JSON.stringify(simplesearch))
    return {
      type: SET_SIMPLESEARCH_WORKSCREEN,
      simplesearch
    }
  } else {
    window.localStorage.setItem('simpleSearch', JSON.stringify(simplesearch))
    return {
      type: SET_SIMPLESEARCH,
      simplesearch
    }
  }
}

/**
 * @description Returns payload for dispatching SET_ORDERS
 * @param {Object} orders Object containing orders
 */
export function SetOrders (orders) {
  return {
    type: SET_ORDERS,
    orders
  }
}
/**
 * @description Returns payload for dispatching SET_ORDERS
 * @param {Object} orders Object containing orders
 */
export function SetWorkscreenOrders (orders) {
  return {
    type: SET_WORKSCREEN_ORDERS,
    orders
  }
}

/**
 * @description Returns payload for dispatching SET_ORDERS
 * @param {Object} orders Object containing orders
 */
export function SetOrdersUpdated (order, groupIndex, itemIndex) {
  return {
    type: SET_ORDERS,
    newUpdatedOrder: order,
    newUpdatedOrderGroupIndex: groupIndex,
    newUpdatedOrderItemIndex: itemIndex
  }
}

export function resetFilter (source) {
  return dispatch => {
    dispatch(resetOrderFilter(source))
  }
}

export function resetSimplesearch (source) {
  return dispatch => {
    dispatch(resetSimplesearchType(source))
  }
}

export function setSimplesearch (simplesearch, source) {
  return dispatch => {
    dispatch(setSimplesearchType(simplesearch, source))
  }
}

/**
 * @description Resets the order to {}
 * @param {Object} order Object order
 */
export function resetOrder () {
  return dispatch => {
    dispatch(setOrder({}))
  }
}

/**
 * @description Get rejected evaluations from API
 * @return {Promise} Axios promise
 */
export function getRejectedEvaluations (orderId) {
  let url = API_URL + '/Order/RejectedEvaluations/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}
/**
 * @description New way to get orders
 * @return {Promise} Axios promise
 */
export function getOrdersNew (data) {
  // console.log('getNewOrder data', data)
  let url = API_URL + '/Order/Search'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting orders from API and dispatching SetOrders
 * @return {Promise} Axios promise
 */
export function getOrders (search) {
  // console.log('search', search)
  let url = API_URL + '/FilterOrders' + search
  return dispatch => {
    return axios.get(url).then(res => {
      let value = res.data.value[0]
      dispatch(SetOrders(value.Steps))
      dispatch(setOrderErrors(false))
      return res
    }, (err) => {
      if (err) {
        dispatch(setOrderErrors(true))
        return err
      }
    })
  }
}

export function getOrderSorting (step, orderIds) {
  // console.log('Get order sorting ', step, orderIds)
  let url = API_URL + '/Order/OrderSearchSorting'
  let data = {
    StepId: step,
    OrderIds: orderIds
  }
  return dispatch => {
    return axios.post(url, data).then(res => {
      return res
    }, (err) => {
      if (err) {
        return err
      }
    })
  }
}

/**
 * @description Updating redux state with new orders
 */
export function updateOrderList (orders) {
  // console.log('updateOrderList', orders)
  return dispatch => {
    dispatch(SetOrders(orders))
    dispatch(setOrderErrors(false))
  }
}
export function updateWorkscreenList (orders) {
  // console.log('updateWorkscreenList', orders)
  return dispatch => {
    dispatch(SetWorkscreenOrders(orders))
  }
}

/**
 * @description Updating redux state with new orders single item
 */
export function updateOrderListSingle (order, groupIndex, itemIndex) {
  // console.log('testSingleUpdate')
  return dispatch => {
    dispatch(SetOrdersUpdated(order, groupIndex, itemIndex))
    dispatch(setOrderErrors(false))
  }
}

/**
 * @description Getting orders from API (advanced) and dispatching SetOrders
 * @return {Promise} Axios promise
 */
export function getOrdersAdvanced (data, userType) {
  // console.log('getOrdersAdvanced', data)
  let url = API_URL + '/Order/Search'
  let filterData = JSON.parse(JSON.stringify(data))
  // Never fetch archived orders
  // filterData.process.Completed = false
  // New Draft logic
  if (typeof filterData.process !== 'undefined') {
    if (hasAccess([4], userType)) {
      filterData.CreatedByRole = 4
    } else {
      if (filterData.process.draft1) { // clients
        filterData.CreatedByRole = 3
      }
      if (filterData.process.draft2) { // self
        filterData.CreatedByRole = 4
      }
      if (filterData.process.draft1 && filterData.process.draft2) {
        filterData.CreatedByRole = null
      }
    }
  }
  // console.log('find orders', filterData)
  return dispatch => {
    return axios.post(url, filterData).then((res) => {
      let value = res.data[0]
      let errors = { NoOrders: true }
      dispatch(SetOrders(value.Steps))
      dispatch(setOrdersSearch(false))
      value.Steps.map((val) => {
        if (val.Orders.length > 0) {
          errors = false
        }
      })
      dispatch(setOrderErrors(errors))
      return res
    }, (err) => {
      if (err) {
        dispatch(setOrderErrors(true))
        return err
      }
    })
  }
}

/**
 * @description Moving an order
 * @return {Promise} Axios promise
 */
export function moveOrder (data) {
  let url = API_URL + '/Order/MoveOrder'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Requests info on available steps for an order.
 * @param {Order id} orderId
 */
export function getSteps (orderId) {
  let url = API_URL + '/GetSteps/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Requests info on available steps for an order that are ahead of its current step.
 * @param {Order id} orderId
 * @param {True to include the order's current step in the result} includeCurrentStep
 */
export function getStepsAhead (orderId, includeCurrentStep = false) {
  let url = API_URL + '/GetStepsAhead/' + orderId
  if (includeCurrentStep === true) {
    url += '?includeCurrent=true'
  }
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Requests info on available steps for an order that are behind its current step.
 * @param {Order id} orderId
 * @param {True to include the order's current step in the result} includeCurrentStep
 */
export function getStepsBehind (orderId, includeCurrentStep = false) {
  let url = API_URL + '/GetStepsBehind/' + orderId
  if (includeCurrentStep === true) {
    url += '?includeCurrent=true'
  }
  return dispatch => {
    return axios.get(url)
  }
}

export function getNextStep (orderId) {
  let url = API_URL + '/GetNextStep/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting order from api and dispatching SetOrder
 * @return {Promise} Axios promise
 */
export function getOrder (orderID) {
  let url = API_URL + '/WorkCard/Get/' + orderID
  return dispatch => {
    return axios.get(url).then(res => {
      let valueShown = res.data.EstimatedProcessTime
      if (valueShown === null || Number.isNaN(valueShown) || valueShown === 0) {
        valueShown = null
      } else {
        valueShown /= 60
      }
      res.data.EstimatedProcessTimeShown = valueShown
      dispatch(SetOrderAction(res.data))
      dispatch(SetWorkcardOrderAction(res.data))
      return res
    })
  }
}

export function getOrderSimple (orderID) {
  let url = API_URL + '/WorkCard/Get/' + orderID
  return dispatch => {
    return axios.get(url).then(res => {
      return res
    })
  }
}

export function getOrderClean (orderID) {
  let url = API_URL + '/WorkCard/Get/' + orderID
  return dispatch => {
    return axios.get(url).then(res => {
      return res
    })
  }
}

/**
 * @description Saving an order
 * @return {Promise} Axios promise
 */
export function saveOrder (data) {
  let url = API_URL + '/WorkCard/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description Update delivery time
 * @return {Promise} Axios promise
 */
export function updateDeliveryTime (data) {
  let url = API_URL + '/WorkCard/DeliveryTime/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Booking an order
 * @return {Promise} Axios promise
 */
export function bookOrder (data) {
  let url = API_URL + '/Order/Book/Paint'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Setting the order
 */
export function setOrder (data) {
  let valueShown = data.EstimatedProcessTime
  if (valueShown === null || Number.isNaN(valueShown) || valueShown === 0) {
    valueShown = null
  } else {
    valueShown /= 60
  }
  data.EstimatedProcessTimeShown = valueShown
  return dispatch => {
    dispatch(SetOrderAction(data))
  }
}
/**
 * @description Setting the order
 */
export function setWorkcardOrder (data) {
  return dispatch => {
    dispatch(SetWorkcardOrderAction(data))
  }
}

/**
 * @description Creating an order using the API
 * @return {Promise} Axios promise
 */
export function createOrder (data) {
  let url = FILE_STORAGE_API + '/order/create'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Creating estimation order using the API
 * @return {Promise} Axios promise
 */
export function createOrderEstimation (data) {
  let url = FILE_STORAGE_API + '/order/evaluation/create'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Skips order check
 * @return {Promise} Axios promise
 */
export function skipOrderCheck (data) {
  let url = API_URL + '/Order/OrderCheck/Skip'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Deletes an order using the API
 * @return {Promise} Axios promise
 */
export function deleteOrder (id, step, index) {
  let url = API_URL + '/order/delete/' + id
  return (dispatch, getState) => {
    return axios.post(url, {}).then((res) => {
      let orders = [...getState().orders.orders]
      // delete orders[step].Orders[index].IsDeleted
      if (index === undefined) {
        index = orders[step].Orders.findIndex((o) => { return o.Id === id })
      }
      orders[step].Orders[index].IsDeleted = true
      dispatch(SetOrders(orders))
      return res
    })
  }
}

/**
 * @description Deletes an order using the API - SIMPLE
 * @return {Promise} Axios promise
 */
export function deleteOrderSimple (id) {
  let url = API_URL + '/order/delete/' + id
  return dispatch => {
    return axios.post(url, {})
  }
}

/**
 * @description Connect an old and new order
 * @return {Promise} Axios promise
 */
export function ConnectOrder (data) {
  let url = API_URL + '/order/connectorders'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting vehicle data from api and returning axios promise
 * @return {Promise} Axios promise
 */
export function getOrderVehicleData (vehicleInfo, vehicleInfoType) {
  let url = API_URL + '/Order/Vehicle'
  return dispatch => {
    return axios.post(url, {
      VehicleInfo: vehicleInfo,
      VehicleInfoType: vehicleInfoType
    })
  }
}

/**
 * @description Getting forsi data from api and returning axios promise
 * @return {Promise} Axios promise
 */
export function getForsiData (id) {
  let url = FILE_STORAGE_API + '/Report/Fetch/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Check if file processing is complete server side
 * @return {Promise} Axios promise
 */
export function isFileReady (orderFileId) {
  let url = FILE_STORAGE_API + '/FileService/IsFileReady/' + orderFileId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting icon url for a filename
 * @return {Promise} Axios promise
 */
export function getFileIcon (fileName) {
  let url = API_URL + '/FileService/GetIcon?fileName=' + fileName
  return dispatch => {
    return axios.get(url)
  }
}

export function createFileContainer (orderPriceId = null, deviationId = null) {
  let url = FILE_STORAGE_API + '/FileService/CreateFileContainer'
  let params = []
  if (orderPriceId !== null) params.push('OrderPriceId=' + orderPriceId)
  if (deviationId !== null) params.push('DeviationId=' + deviationId)

  for (let i = 0; i < params.length; i++) {
    if (i === 0) {
      url += '?' + params[i]
    } else {
      url += '&' + params[i]
    }
  }
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Uploading a file to an order
 * @return {Promise} Axios promise
 */
export function uploadFileToOrder (file, orderid, type, priceid, fileContainerId) {
  let url = FILE_STORAGE_API + '/FileService/Upload?OrderID=' + orderid
  if (fileContainerId !== undefined && fileContainerId !== null) {
    url += '&fileContainerId=' + fileContainerId
  }
  let data = new window.FormData()
  data.append(file.name, file)
  if (typeof type !== 'undefined') {
    data.append('Type', type)
  }
  if (typeof priceid !== 'undefined') {
    data.append('OrderPriceId', priceid)
  }

  // if iOS image rotate
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  if (isiOS && file.type.indexOf('image/') !== -1) {
    // file.rotation = 1
    data.append('Rotation_' + 0, file.rotation)
  }
  // return dispatch => {
  //   let key = Math.floor(Math.random() * 10000000)
  //   const config = {
  //     onUploadProgress: evt => {
  //       updateUploads(key, file, evt)
  //     }
  //   }
  //   return axios.post(url, data, config)
  // }

  // console.log('uploadFileToOrder')
  return queueUpload(url, file, data)
}

/**
 * @description Uploading multiples files to an order
 * @return {Promise} Axios promise
 */
export function uploadMultipleFiles (files, orderid, type, priceid, fileContainerId, orderNoteId) {
  let url = FILE_STORAGE_API + '/FileService/Upload?OrderID=' + orderid
  let data = new window.FormData()
  if (fileContainerId !== undefined && fileContainerId !== null) {
    url += '&fileContainerId=' + fileContainerId
  }
  if (orderNoteId !== undefined && orderNoteId !== null) {
    url += '&orderNoteId=' + orderNoteId
  }
  // console.log('uploadMultipleFiles', files, orderid, 'fileContainerId', fileContainerId)
  files.map((val, index) => {
    // console.log('index', index)
    if (typeof val.file === 'undefined') {
      data.append(val.name, val)
    } else {
      data.append(val.file.name, val.file)
    }
    if (typeof val.rotation !== 'undefined') {
      // console.log('index', index, val.rotation)
      data.append('Rotation_' + index, val.rotation)
    }
  })
  if (typeof type !== 'undefined') {
    data.append('Type', type)
  }
  if (typeof priceid !== 'undefined') {
    data.append('OrderPriceId', priceid)
  }

  return queueUpload(url, null, data)
  // return dispatch => {
  //   let key = Math.floor(Math.random() * 10000000)
  //   const config = {
  //     onUploadProgress: evt => {
  //       updateUploads(key, file, evt)
  //     }
  //   }
  //   return axios.post(url, data, config)
  // }
}

/**
 * @description Uploading markings to files
 * @return {Promise} Axios promise
 */
export function uploadImageMarkings (data) {
  let url = FILE_STORAGE_API + '/FileService/UploadMarkings'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Connects images to photodocumentation
 * @return {Promise} Axios promise
 */
export function createPhotoDoc (data) {
  let url = FILE_STORAGE_API + '/Order/Photodocumentation/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Deletes a files from an order
 * @return {Promise} Axios promise
 */
export function deleteFileFromOrder (file) {
  let url = FILE_STORAGE_API + '/FileService/Delete/'
  return dispatch => {
    return axios.post(url, {
      ItemID: file.OrderFileID
    })
  }
}

export function deleteDeviationFileFromOrder (file) {
  let fileId = (typeof file.OrderFileID !== 'undefined') ? file.OrderFileID : file.OrderFile.OrderFileID
  let url = FILE_STORAGE_API + '/FileService/Delete/'
  return dispatch => {
    return axios.post(url, {
      ItemID: fileId
    })
  }
}

/**
 * @description Gets/validates pickup times.
 * @return {Promise} Axios promise
 */
export function getPickupTimes (pickupDate, pickupTime, customerId, department) {
  let url = API_URL + '/Order/ValidatePickupTime/'
  return dispatch => {
    return axios.post(url, {
      PickupDate: pickupDate,
      PickupTime: pickupTime,
      CustomerId: customerId,
      Department: department
    })
  }
}

/**
 * @description Gets/validates pickup times.
 * @return {Promise} Axios promise
 */
export function getAvailablePickupTimes (data) {
  let url = API_URL + '/Order/PickupTimes/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Gets next delivery times.
 * @return {Promise} Axios promise
 */
export function getNextDeliveryTimes (pickupDate, pickupTime, customerId, orderPrice, orderType, isLoosePart, orderId, department) {
  let url = API_URL + '/Order/NextDeliveryTime/'
  return dispatch => {
    return axios.post(url, {
      PickupDate: pickupDate,
      PickupTime: pickupTime,
      CustomerId: customerId,
      OrderPrice: orderPrice,
      OrderType: orderType,
      IsLoosePart: isLoosePart,
      OrderId: orderId,
      Department: department
    })
  }
}

/**
 * @description Gets valid delivery times.
 * @return {Promise} Axios promise
 */
export function getDeliveryTimes (deliveryDate, department, orderId) {
  let url = API_URL + '/Order/DeliveryTimes/'

  return dispatch => {
    return axios.post(url, {
      DeliveryDate: deliveryDate,
      Department: department,
      OrderId: orderId
    })
  }
}

/**
 * @description Start order
 * @return {Promise} Axios promise
 */
export function startOrder (data) {
  let url = API_URL + '/Order/Start'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Stop order
 * @return {Promise} Axios promise
 */
export function stopOrder (data) {
  let url = API_URL + '/Order/Stop'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get order inspection
 * @return {Promise} Axios promise
 */
export function getOrderInspection (id) {
  let url = API_URL + '/OrderInspection/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save order inspection
 * @return {Promise} Axios promise
 */
export function saveOrderInspection (data) {
  let url = API_URL + '/OrderInspection/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get ManualMerge Orders
 * @return {Promise} Axios promise
 */
export function getManualMerge (id) {
  let url = API_URL + '/Order/ManualMerge/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Merge Orders
 * @return {Promise} Axios promise
 */
export function ManualMerge (data) {
  let url = API_URL + '/Order/ManualMerge'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get link order data
 * @return {Promise} Axios promise
 */
export function getLinkOrderData (id) {
  let url = API_URL + '/Order/LinkMatch/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Link Orders
 * @return {Promise} Axios promise
 */
export function LinkOrders (data) {
  let url = API_URL + '/Order/Link'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Reference Order
 * @return {Promise} Axios promise
 */
export function ReferenceOrder (data) {
  let url = API_URL + '/Order/Reference'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description get Reference Order info
 * @return {Promise} Axios promise
 */
export function GetReferenceOrderInfo (id) {
  let url = API_URL + '/Order/Reference/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description edit the reference (approve og decline)
 * @return {Promise} Axios promise
 */
export function ReferenceEdit (data) {
  let url = API_URL + '/Order/Reference/edit'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get Log
 * @return {Promise} Axios promise
 */
export function GetLog (id) {
  let url = API_URL + '/Order/Log/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get Order Notifications
 * @return {Promise} Axios promise
 */
export function GetOrderNotifications (id) {
  let url = API_URL + '/Order/Notifications/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get Order deadlines
 * @return {Promise} Axios promise
 */
export function GetDeadlineTimes (id) {
  let url = API_URL + '/Order/GetDeadlineTimes/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Update ProductionDate
 * @return {Promise} Axios promise
 */
export function UpdateProductionDate (data) {
  let url = API_URL + '/Order/Productiondate/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Update DeliveryDate
 * @return {Promise} Axios promise
 */
export function UpdateDeliveryDate (data) {
  let url = API_URL + '/Order/Productiondate/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Stop order in current step
 * @return {Promise} Axios promise
 */
export function StopLockOrder (data) {
  let url = API_URL + '/Order/StopLock/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get new delivery time for resume of the stopped order
 * @return {Promise} Axios promise
 */
export function GetNewDeliveryForResume (orderId) {
  let url = API_URL + '/Order/ResumeOrderNewDelivery/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Fetches archived orders
 * @return {Promise} Axios promise
 */
export function getArchivedOrders (data) {
  let url = API_URL + '/Order/GetArchived'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Updates paint on order
 * @return {Promise} Axios promise
 */
export function updatePaint (data) {
  let url = API_URL + '/Order/UpdatePaint/'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function updatePrice (data) {
  let url = API_URL + '/Order/UpdatePrice/'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function updateRekvNumber (data) {
  let url = API_URL + '/Order/UpdateRekvNumber/'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function setCustomer (orderId, customerId) {
  let url = API_URL + '/Order/SetCustomer/'
  let data = {
    OrderId: orderId,
    CustomerId: customerId
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

export function hasExtent (orderId) {
  let url = API_URL + '/Order/HasManualExtent?orderId=' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get order extends
 * @return {Promise} Axios promise
 */
export function GetExtends (id) {
  let url = API_URL + '/Order/Extends/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get orders that is being workt on nown ad the employees
 * @return {Promise} Axios promise
 */
export function getOrdersInStep (step) {
  let url = API_URL + '/Order/OrdersWorkStep/' + step
  return dispatch => {
    return axios.get(url)
  }
}
/**
 * @description Get delivery changes
 * @return {Promise} Axios promise
 */
export function GetDeliveryChange (date) {
  let url = API_URL + '/Order/GetDeliveryChange/'
  return dispatch => {
    return axios.post(url, date)
  }
}

/**
 * @description Getting order files
 * type: 0 or undefined = all, 1 = images, 2 = files
 * @return {Promise} Axios promise
 */
export function getOrderFiles (orderID, type) {
  // let url = API_URL + '/Order/OrderFiles/Get/' + orderID
  // return dispatch => {
  //   return axios.get(url).then(res => {
  //     dispatch(SetOrderAction(res.data.orderFile))
  //     return res
  //   })
  // }
  let url = FILE_STORAGE_API + '/Order/OrderFiles/Get/' + orderID
  if (type !== undefined) {
    url += '?type=' + type
  }
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Update OrderFileSelection
 * @return {Promise} Axios promise
 */
export function UpdateOrderFileSelection (data) {
  let url = API_URL + '/Order/OrderFileSelection/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting items for Assessment in order inspection
 * @return {Promise} Axios promise
 */
export function GetAssessmentItemsInOrderInspection (id, department) {
  let url = API_URL + '/Order/AssessmentItems/Get/' + id + (typeof department !== 'undefined' ? ('?department=' + department) : '')
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Update Economic match type
 * @return {Promise} Axios promise
 */
export function UpdateEconomicMatch (data) {
  let url = API_URL + '/Order/HandleEconomicMatch'
  // console.log(data)
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Update Economic match type
 * @return {Promise} Axios promise
 */
export function GetInvoiceLog (orderId) {
  let url = API_URL + '/Order/InvoiceLog/Get/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}
/**
 * @description Update Economic match type
 * @return {Promise} Axios promise
 */
export function GetOrderInvoiceLog (orderId) {
  let url = API_URL + '/GetLog/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}
/**
 * @description Update ProductionDate
 * @return {Promise} Axios promise
 */
export function DeleteExifData (images) {
  let url = FILE_STORAGE_API + '/Order/DeleteExifData'
  let data = []
  images.map((val) => {
    data.push({
      Base64: val.imageUrl,
      Name: val.file.name
    })
  })
  return queueUpload(url, null, data)
  // return dispatch => {
  //   return axios.post(url, data)
  // }
}

/**
 * @description Rotate image
 * @return {Promise} Axios promise
 */
export function rotateImages (images) {
  let url = FILE_STORAGE_API + '/FileService/rotateImages'

  return dispatch => {
    return axios.post(url, images)
  }
}

/**
 * @description Mark the order as totally wrecked
 * @return {Promise} Axios promise
 */
export function markAsWrecked (orderId) {
  let url = API_URL + '/Order/MarkAsWrecked'
  return dispatch => {
    return axios.post(url, orderId)
  }
}

/**
 * @description Delete report from order extent
 * @return {Promise} Axios promise
 */
export function resetReport (orderId) {
  let url = FILE_STORAGE_API + '/Order/Report/Delete'
  return dispatch => {
    return axios.post(url, orderId).then((res) => {
      return res
    })
  }
}

/**
 * @description Gets information on the current type of extent (base and addon) for an order.
 * @param {Number} orderId
 * @return {Promise} Axios promise
 */
export function getExtentInfo (orderId) {
  let url = API_URL + '/Order/ExtentInfo/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Set the orderId of the last visited order
 */
export function setLastVisitedOrderId (orderId) {
  return dispatch => {
    dispatch({
      type: SET_LAST_VISITED_ORDER,
      orderId: orderId
    })
  }
}

/**
 * @description Clear the orderId of the last visited order
 */
export function clearLastVisitedOrderId () {
  return dispatch => {
    dispatch({
      type: SET_LAST_VISITED_ORDER,
      orderId: undefined
    })
  }
}

  /**
   *
   * @param {Array} identificationIds
   * the orderIds from the socket to be update
   * @param {Array} myOrders
   * the orders you can see in the list right now
   * @returns
   * true if the identificationIds included in myOrders, otherwise false
   */
export function mustOrderUpdateDueToSocket (identificationIds, myOrders) {
  // console.log('MustOrderUpdateDueToSocket', myOrders)
  let orders = myOrders.map(x => x.Orders).filter((x) => x.length > 0)
  let orderIds = []
  for (let index = 0; index < orders.length; index++) {
    const elements = orders[index]
    for (let i = 0; i < elements.length; i++) {
      orderIds.push(elements[i].Id)
    }
  }

  let isIncluded = orderIds.some(x => identificationIds.includes(x))
  // console.log('orderIds', orderIds)
  // console.log('identificationIds', identificationIds)
  // console.log('isIncluded', isIncluded)

  if (isIncluded) return true
  return false
}



// WEBPACK FOOTER //
// ./src/app/actions/orders.js